import React, { useState, useEffect } from 'react';
import { Card, CardTitle, Grid, MetricCard, Insight } from '../components/UI';
import { supabase } from '../supabaseClient';
const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';
function useIsMobile() {
  const [m,setM]=React.useState(()=>typeof window!=='undefined'&&window.innerWidth<768);
  React.useEffect(()=>{const h=()=>setM(window.innerWidth<768);window.addEventListener('resize',h);return()=>window.removeEventListener('resize',h);},[]);
  return m;
}
export default function TeamProductivity() {
  const isMobile = useIsMobile();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const today = new Date().toISOString().slice(0,10);
  const weekAgo = new Date(Date.now()-7*24*60*60*1000).toISOString().slice(0,10);

  useEffect(() => {
    (async () => {
      const [
        {count:verifiedToday},
        {count:verifiedWeek},
        {count:ticketsOpen},
        {count:ticketsResolvedWeek},
        {data:recentVerifs},
        {data:actLog},
      ] = await Promise.all([
        supabase.from('Locations').select('*',{count:'exact',head:true}).eq('last_verified',today),
        supabase.from('Locations').select('*',{count:'exact',head:true}).gte('last_verified',weekAgo),
        supabase.from('support_tickets').select('*',{count:'exact',head:true}).eq('status','open'),
        supabase.from('support_tickets').select('*',{count:'exact',head:true}).eq('status','resolved').gte('resolved_at',weekAgo),
        supabase.from('Locations').select('name,type,country,last_verified').eq('last_verified',today).limit(10),
        supabase.from('activity_log').select('action,entity,created_at,user_email').order('created_at',{ascending:false}).limit(20),
      ]);
      setStats({verifiedToday:verifiedToday||0,verifiedWeek:verifiedWeek||0,ticketsOpen:ticketsOpen||0,ticketsResolvedWeek:ticketsResolvedWeek||0,recentVerifs:recentVerifs||[],actLog:actLog||[]});
      setLoading(false);
    })();
  }, []);

  return (
    <div style={{fontFamily:F,padding:isMobile?'16px 14px 80px':'24px 28px'}}>
      <div style={{marginBottom:20}}>
        <h2 style={{fontSize:'1.1rem',fontWeight:500,margin:0,color:'var(--color-text-primary)'}}>Team productivity</h2>
        <p style={{fontSize:'.78rem',color:'var(--color-text-secondary)',margin:'4px 0 0'}}>Daily and weekly summary of verifications, ticket resolution, and admin activity.</p>
      </div>
      <Grid cols={4} style={{marginBottom:20}}>
        <MetricCard label="Verified today" value={loading?'…':(stats?.verifiedToday||0).toLocaleString()} accent="#28a745"/>
        <MetricCard label="Verified this week" value={loading?'…':(stats?.verifiedWeek||0).toLocaleString()} accent="#314F5C"/>
        <MetricCard label="Open tickets" value={loading?'…':(stats?.ticketsOpen||0).toString()} accent={stats?.ticketsOpen>0?'#fd7e14':'#28a745'}/>
        <MetricCard label="Tickets resolved (7d)" value={loading?'…':(stats?.ticketsResolvedWeek||0).toString()} accent="#6F8FA7"/>
      </Grid>
      <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'1fr 1fr',gap:16}}>
        <Card>
          <CardTitle>Verified today ({stats?.recentVerifs?.length||0})</CardTitle>
          {loading?<div style={{color:'var(--color-text-secondary)',fontSize:'.75rem'}}>Loading…</div>:
           stats?.recentVerifs?.length===0?<Insight type="info">No verifications recorded today yet.</Insight>:
           stats?.recentVerifs?.map((r,i)=>(
            <div key={i} style={{padding:'5px 0',borderBottom:'.5px solid var(--color-border-tertiary)'}}>
              <div style={{fontSize:'.75rem',fontWeight:500,color:'var(--color-text-primary)'}}>{r.name}</div>
              <div style={{fontSize:'.65rem',color:'var(--color-text-secondary)'}}>{[r.type,r.country].filter(Boolean).join(' · ')}</div>
            </div>
           ))
          }
        </Card>
        <Card>
          <CardTitle>Recent admin activity</CardTitle>
          {loading?<div style={{color:'var(--color-text-secondary)',fontSize:'.75rem'}}>Loading…</div>:
           stats?.actLog?.length===0?<Insight type="info">No activity log entries yet. Activity logging requires an activity_log table.</Insight>:
           stats?.actLog?.map((r,i)=>(
            <div key={i} style={{padding:'5px 0',borderBottom:'.5px solid var(--color-border-tertiary)'}}>
              <div style={{fontSize:'.75rem',fontWeight:500,color:'var(--color-text-primary)'}}>{r.action} {r.entity}</div>
              <div style={{fontSize:'.65rem',color:'var(--color-text-secondary)'}}>{r.user_email} · {r.created_at?.slice(0,16)}</div>
            </div>
           ))
          }
        </Card>
      </div>
    </div>
  );
}
